import React from 'react'
import { Link } from 'react-router-dom'

import { formatDateShort } from '../../lib/dates'
import { useAuth } from '../../context/auth'
import { Invoice, InvoiceStatus } from '../../types'
import Amount from '../ui/currency/amount'
import StatusBadge from './statusBadge'
import Button, { ButtonSize, ButtonVariant } from '../ui/button'
import { ReactComponent as CheckIcon } from '../../static/images/check.svg'
import InvoiceActionsDropdown from './invoiceActionsDropdown'
import { ReactComponent as EyeIcon } from '../../static/images/eye.svg'

import './styles.scss'

type Props = {
  invoice: Invoice
  handlePaid: (invoice: Invoice) => void
  onInvoiceDeleted?: () => void
  isUpdating?: boolean
  isRemoving?: boolean
}
const InvoiceCard: React.FC<Props> = ({
  invoice,
  handlePaid,
  onInvoiceDeleted,
  isUpdating = false,
  isRemoving = false,
}) => {
  const { user } = useAuth()
  const [isExpanded, setIsExpanded] = React.useState(false)
  return (
    <div
      className={`card mb-3 shadow-sm ${isExpanded ? 'border-secondary' : ''} ${isRemoving ? 'invoice-card--removing' : ''}`}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className='card-body'>
        <div className='d-flex align-items-center justify-content-between'>
          <small className='text-muted'>{formatDateShort(invoice.issueDate, user?.locale)} | {invoice.code}</small>
          <div className=''>{<StatusBadge status={(invoice.status as InvoiceStatus)} />}</div>
        </div>
        <div className='invoice-card__title-row'>
          <h5 className='mb-0'>{invoice.client?.tradingName}</h5>
          <div>
            <b className='text-primary'>
              <Amount value={invoice.total as number} currencySymbol={invoice?.businessDetails?.currency?.symbol} />
            </b>
          </div>
        </div>
        {isExpanded && (
          <div className='mt-4 d-flex align-items-center justify-content-end gap-3 flex-wrap'>
            <Link to={`/invoices/${invoice._id}`} onClick={(e) => e.stopPropagation()}>
              <Button 
                variant={ButtonVariant.SECONDARY}
                icon={<EyeIcon width={20} height={20} />}
                iconPosition='start'
              >
                View
              </Button>
            </Link>
            {invoice.status !== InvoiceStatus.PAID && (
              <Button
                icon={<CheckIcon width={20} height={20} />}
                iconPosition='start'
                variant={ButtonVariant.SECONDARY}
                size={ButtonSize.AUTO}
                loading={isUpdating}
                loadingText='Updating invoice'
                onClick={(e) => { e.stopPropagation(); handlePaid(invoice) }}
              >
                Mark paid
              </Button>
            )}
            <InvoiceActionsDropdown invoice={invoice} onDeleted={onInvoiceDeleted} disabled={isUpdating} />
          </div>
        )}
      </div>
    </div>
  )
}

export default InvoiceCard
